const About = ({ closeApp }) => {
    return (
        <div style={{ marginBottom: '100px' }}>

            <div style={{ textAlign: 'left' }}>

                <h2 style={{ marginLeft: '40px', marginBottom: '0px', fontSize: '1.4em' }}>About</h2>

                <div style={{ marginLeft: '40px', marginRight: '30px', fontSize: '0.7em' }}>
                    <br />
                    
                    
                    
                    
                    
                    iOS in React<br />
                    <div style={{ fontSize: '0.8em' }}>Chris Carey, 2021</div>
                    
                    <div style={{ fontSize: '0.8em' }}>
                    
                        Made with React, Framer Motion<br />
                        <br />
                        
                        Making progress on:<br />
                        <ul>
                            <li>Swipe to change pages</li>
                            <li>Active page "bubbles" at the bottom of the screen</li>
                            <li>App launch, app close animations using 'transform' CSS for GPU accelerated transitions</li>
                            <li>Blur and scale down the background on app launch</li>
                        </ul>

                        

                        TODO:

                        <ul>
                            <li>React Router to maintain state</li>
                            <li>Swipe up at the bottom of the page to quit app</li>
                            <li>Fix the top bar to look right, fix time/date format</li>
                            <li>Settings page, change wallpaper, change animation speed</li>
                            <li>Folders</li>
                            <li>Swipe down to open Search and Siri Suggestions</li>
                            <li>Swipe right from page 1 to go to widgets</li>
                            <li>Build out a few more apps</li>
                        </ul>

                        Bugs:

                        <ul>
                            <li>Everywhere</li>
                        </ul>

                    </div>
                    

                </div>
            </div>

            

            
            <div className="app-open-controls app-open-controls-single">
                <div className="app-open-control-item"><button onClick={closeApp}>Close App</button></div>
            </div>
            
        </div>
    );
};
export default About;